import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LeftShape, RightShape } from '.';
import { useCallback } from 'react';
export const Stage = ({ stage, state, position = 'middle', onClick }) => {
    const handleClick = useCallback(() => onClick === null || onClick === void 0 ? void 0 : onClick(stage), [onClick, stage]);
    return (_jsxs("div", Object.assign({ className: `btn-arrow ${state} ${position}`, onClick: handleClick }, { children: [position !== 'first' && _jsx(LeftShape, {}), _jsx("div", Object.assign({ className: 'stage' }, { children: stage })), position !== 'last' && _jsx(RightShape, {})] })));
};
